import { Button, makeStyles } from "@material-ui/core";
import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectWhat } from "../store/engine/engineReducer";

const useStyles = makeStyles(() => ({
  button: {
    width: 192,
    minHeight: 48,
  },
}));

interface Props {
  vivere?: boolean;
  muoversi?: boolean;
  dipendente?: boolean;
  prezzo?: number;
  complete?: boolean;
}

export const SelectButtonWhat: FC<Props> = ({
  vivere = false,
  muoversi = false,
  dipendente = false,
  prezzo,
  complete,
}: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const handleClick = (): void => {
    if (prezzo) {
      dispatch(selectWhat(vivere, muoversi, dipendente, prezzo, history));
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.button}
      onClick={handleClick}
      disabled={!complete}
      data-test={`select-what-${vivere}-${muoversi}-${dipendente}`}
      disableElevation
    >
      Seleziona
    </Button>
  );
};
